import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=050e3445&scoped=true&lang=pug&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=050e3445&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e3445",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('050e3445', component.options)
    } else {
      api.reload('050e3445', component.options)
    }
    module.hot.accept("./toolbar.vue?vue&type=template&id=050e3445&scoped=true&lang=pug&", function () {
      api.rerender('050e3445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/component_editor/component/toolbar/toolbar.vue"
export default component.exports